var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var QboFormElement_1;
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { substitute } from './qbo-json.js';
let QboFormElement = class QboFormElement extends LitElement {
    static { QboFormElement_1 = this; }
    static { this.formAssociated = true; }
    constructor() {
        super();
        this.value = new FormData();
        this.template = '';
        this.name = '';
        this.data = null;
        this.templateNode = null;
        this.handleFormChange = (event) => {
            const target = event.target;
            if (target.matches('input, select, textarea') && target.name && !target.assignedSlot) {
                // if the element is assigned to a slot, it's already visible to the parent. Ignore it.
                this.value.set(`${this.name}${target.name}`, target.value);
                console.trace(`${this.name}${target.name} was set to ${target.value}`);
            }
            this.internals.setFormValue(this.value);
            this.dispatchEvent(new CustomEvent('qbo-form-update', { bubbles: true, composed: true, detail: { formData: this.value } }));
        };
        this.augment = (event) => {
            event.stopPropagation();
            console.log(event);
            if (event instanceof CustomEvent && event.detail.formData instanceof FormData) {
                // To replace existing entries instead of appending
                for (let [key, value] of event.detail.formData.entries()) {
                    this.value.set(key, value);
                    console.log(`Added ${key}=${value} to ${this.name}`);
                }
            }
            this.internals.setFormValue(this.value);
            this.dispatchEvent(new CustomEvent('qbo-form-update', { bubbles: true, composed: true, detail: { formData: this.value } }));
        };
        this.internals = this.attachInternals(); // Attach the form internals
    }
    connectedCallback() {
        super.connectedCallback();
        this.templateNode = document.getElementById(this.template);
        if (this.templateNode) {
            this.appendChild(this.templateNode.content.cloneNode(true));
            this.innerHTML = substitute(this.innerHTML, this.data);
        }
        this.shadowRoot?.addEventListener('change', this.handleFormChange);
        this.shadowRoot?.addEventListener('qbo-form-update', this.augment);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.shadowRoot?.removeEventListener('change', this.handleFormChange);
        this.shadowRoot?.removeEventListener('qbo-form-update', this.augment);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        this.establishFormData();
    }
    render() {
        return html `<slot></slot>`;
    }
    establishFormData() {
        const elements = this.shadowRoot?.querySelectorAll('input, select, textarea');
        if (!elements || elements?.length === 0)
            return;
        const inputs = Array.from(elements).filter(e => !e.assignedSlot
            && (e instanceof HTMLInputElement
                || e instanceof HTMLSelectElement
                || e instanceof HTMLTextAreaElement
                || e instanceof QboFormElement_1) && e.name);
        inputs.forEach(element => {
            const input = element;
            if (input instanceof HTMLSelectElement) {
                this.value.set(`${this.name}${input.name}`, input.value);
            }
            else if (input instanceof HTMLTextAreaElement) {
                this.value.set(`${this.name}${input.name}`, input.value);
            }
            else if (input instanceof QboFormElement_1) {
                for (let [key, value] of input.value.entries()) {
                    this.value.set(`${this.name}${key}`, value);
                }
            }
            else if (input instanceof HTMLInputElement) {
                if (input.type === 'checkbox' || input.type === 'radio') {
                    if (input.checked) {
                        this.value.set(`${this.name}${input.name}`, input.value);
                    }
                }
                else {
                    this.value.set(`${this.name}${input.name}`, input.value);
                }
            }
        });
        this.internals.setFormValue(this.value);
        console.trace(`Set ${this.name} values to `, this.value);
    }
};
__decorate([
    property({ type: FormData }),
    __metadata("design:type", FormData)
], QboFormElement.prototype, "value", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormElement.prototype, "template", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFormElement.prototype, "name", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboFormElement.prototype, "data", void 0);
QboFormElement = QboFormElement_1 = __decorate([
    customElement('qbo-form-element'),
    __metadata("design:paramtypes", [])
], QboFormElement);
export { QboFormElement };
